import axios from 'axios';
import { Dispatch } from 'redux';
import {
  NpcByItemAction,
  NpcByItemActionTypes,
  NpcByItemPayload
} from '../../types/npcByItem';
import { errorHandler } from '../../utils/service';
import { setAlert } from './alert';

const config = {
  headers: {
    'Content-Type': 'application/json'
  }
};
const CancelToken = axios.CancelToken;
let cancelSearch: any = null;

export const getNpcByItem =
  (data: NpcByItemPayload) =>
  async (dispatch: Dispatch<NpcByItemAction | any>) => {
    const body = JSON.stringify(data);
    try {
      dispatch({
        type: NpcByItemActionTypes.SET_NPC_BY_ITEM_LOADING
      });

      const res = await axios.post('/api/npcreports/byitem', body, config);
      dispatch({
        type: NpcByItemActionTypes.GET_NPC_BY_ITEM,
        payload: res.data
      });
    } catch (error) {
      errorHandler({ error, dispatch, setAlert });
      dispatch({
        type: NpcByItemActionTypes.GET_NPC_BY_ITEM,
        payload: {}
      });
    }
  };

export const searchNsItems =
  (text: string) => async (dispatch: Dispatch<NpcByItemAction | any>) => {
    try {
      dispatch({
        type: NpcByItemActionTypes.SET_SEARCH_NS_ITEMS_LOADING
      });

      if (cancelSearch) {
        cancelSearch();
        cancelSearch = null;
      }

      const config2 = {
        cancelToken: new CancelToken(function executor(c) {
          cancelSearch = c;
        })
      };
      const res = await axios.get(
        `/api/npc/search/${encodeURIComponent(text ? text.trim() : '')}`,
        config2
      );
      // Add None option
      if (text?.toLowerCase() === 'none') {
        res.data.unshift({
          id: '',
          sku: 'None',
          description: 'None',
          upc: 'None',
          mpn: 'None'
        });
      }
      dispatch({
        type: NpcByItemActionTypes.SEARCH_NS_ITEMS,
        payload: res.data
      });
    } catch (error) {
      dispatch({
        type: NpcByItemActionTypes.SEARCH_NS_ITEMS,
        payload: []
      });
      errorHandler({
        error,
        dispatch,
        setAlert,
        loadingType: NpcByItemActionTypes.SET_SEARCH_NS_ITEMS_LOADING
      });
    }
  };

export const clearNpcByItem =
  () => async (dispatch: Dispatch<NpcByItemAction>) => {
    dispatch({
      type: NpcByItemActionTypes.CLEAR_NPC_BY_ITEM
    });
  };

export const clearNpcMarkets =
  () => async (dispatch: Dispatch<NpcByItemAction>) => {
    dispatch({
      type: NpcByItemActionTypes.CLEAR_NPC_MARKETS
    });
  };
